import { configureStore } from '@reduxjs/toolkit';
import companyReducer from './companySlice';
import authReducer from './authSlice';
import menuReducer from './menuSlice';
import filterReducer from './filterSlice';

/**
 * Redux store configuration using Redux Toolkit
 * 
 * All slices use createSlice for simplified reducer logic with Immer
 * for immutable updates. Use useSelector and useDispatch hooks to
 * interact with the store instead of connect HOC.
 */
export const store = configureStore({
    reducer: {
        company: companyReducer,
        auth: authReducer,
        menu: menuReducer,
        filter: filterReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types for serialization check
                ignoredActions: ['company/update'],
                // Ignore these field paths in all actions
                ignoredActionPaths: ['payload.timestamp'],
                // Ignore these paths in the state
                ignoredPaths: ['company.lastUpdated', 'menu.lastUpdated'],
            },
        }),
});

// Export types for TypeScript support (optional, for future use)
export const RootState = store.getState;
export const AppDispatch = store.dispatch;
